function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Form, Table, Button, Space, Drawer, Modal, message } from 'antd';
import Moment from 'react-moment';
import AddSettlement from './forms/AddSettlement';
import AddDeliveryReport from './forms/AddDeliveryReport';
import OrderDetailsView from './OrderDetailsView';
import { ThreeDots, CheckCircleFill } from 'react-bootstrap-icons';
import Common from './includes/Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var OrderListView = function OrderListView(_ref) {
  var orderList = _ref.orderList,
    dataRefreshHandler = _ref.dataRefreshHandler,
    loading = _ref.loading;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    orderArrayData = _useState4[0],
    setOrderArrayData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPaymentVisible = _useState6[0],
    setIsPaymentVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDeliveryVisible = _useState8[0],
    setIsDeliveryVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isOrderDetailsVisible = _useState10[0],
    setIsOrderDetailsVisible = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedOrder = _useState12[0],
    setSelectedOrder = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isDataChanged = _useState14[0],
    setIsDataChanged = _useState14[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleOrderValidate = function handleOrderValidate(order) {
    setSelectedOrder(order);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Voulez-vous confirmer ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La commande de ", /*#__PURE__*/_jsxs("b", {
          children: [order.quantity.toLocaleString('Fr'), " Litres"]
        }), " de produit ", /*#__PURE__*/_jsx("b", {
          children: order.product.label
        }), " avec ", /*#__PURE__*/_jsx("b", {
          children: order.provider.label
        })]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "validateorder", {
          order_id: order.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            message.success({
              content: response.data.message,
              delay: 4
            });
            dataRefreshHandler();
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Fourn."
    }),
    dataIndex: 'provider',
    key: 'provider',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Produit"
    }),
    dataIndex: 'product',
    key: 'product',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Qt\xE9 (L)"
    }),
    dataIndex: 'quantity',
    key: 'quantity',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Total (GNF)"
    }),
    dataIndex: 'amount',
    responsive: ['lg', 'md', 'sm'],
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Pay\xE9 (GNF)"
    }),
    dataIndex: 'paid_amount',
    key: 'paid_amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Restant (GNF)"
    }),
    responsive: ['lg', 'md', 'sm'],
    dataIndex: 'rest_amount',
    key: 'rest_amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: '',
    dataIndex: 'order',
    key: 'order',
    render: function render(order) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedOrder(order);
            setIsDeliveryVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "LIVRAIS."
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedOrder(order);
            setIsPaymentVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "PAIEM."
          })
        }), order.status == 0 ? /*#__PURE__*/_jsx(Button, {
          type: "link",
          style: {
            color: '#F27878'
          },
          onClick: function onClick() {
            handleOrderValidate(order);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "VALID."
          })
        }) : /*#__PURE__*/_jsx(Button, {
          disabled: true,
          type: "link",
          style: {
            width: '70px'
          },
          children: /*#__PURE__*/_jsx(CheckCircleFill, {
            style: {
              color: '#85D58C'
            },
            size: 30
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedOrder(order);
            setIsOrderDetailsVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(ThreeDots, {
              size: 25
            })
          })
        })]
      });
    }
  }];
  useEffect(function () {
    setOrderArrayData([]);
    orderList.forEach(function (o) {
      setOrderArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: o.id,
          provider: o.provider.label,
          product: o.product.label,
          quantity: o.quantity,
          amount: o.product.base_price * o.quantity,
          paid_amount: o.paid_amount,
          rest_amount: o.product.base_price * o.quantity - o.paid_amount,
          date: o.created_at,
          order: o
        }]);
      });
    });
  }, [orderList, isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h6", {
      children: /*#__PURE__*/_jsx("b", {
        children: "TABLEAU DES COMMANDES"
      })
    }), /*#__PURE__*/_jsx(Table, {
      bordered: true,
      columns: cols,
      size: "small",
      loading: loading,
      dataSource: orderArrayData
    }), selectedOrder != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "FAIRE UN PAIEMENT"
        }),
        width: "540px",
        destroyOnClose: true,
        open: isPaymentVisible,
        onClose: function onClose() {
          setIsPaymentVisible(false);
        },
        children: /*#__PURE__*/_jsx(AddSettlement, {
          order: selectedOrder,
          handler: function handler() {
            setIsDataChanged(true);
            dataRefreshHandler();
            message.success({
              content: 'Opération reussie !'
            });
            setIsPaymentVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "FAIRE UNE LIVRAISON"
        }),
        width: "540px",
        destroyOnClose: true,
        open: isDeliveryVisible,
        onClose: function onClose() {
          setIsDeliveryVisible(false);
        },
        children: /*#__PURE__*/_jsx(AddDeliveryReport, {
          order: selectedOrder,
          handler: function handler() {
            setIsDataChanged(true);
            dataRefreshHandler();
            message.success({
              content: 'Opération reussie !'
            });
            setIsDeliveryVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS COMMANDE"
        }),
        width: "95%",
        destroyOnClose: true,
        open: isOrderDetailsVisible,
        footer: null,
        onCancel: function onCancel() {
          setIsOrderDetailsVisible(false);
        },
        children: /*#__PURE__*/_jsx(OrderDetailsView, {
          order: selectedOrder
        })
      })]
    })]
  });
};
export default OrderListView;